import Markdown from "react-markdown";
import { useIntl } from "react-intl";

interface AccordionItem {
  title: string;
  content: string;
}

export const Cards = () => {
  const { formatMessage } = useIntl();

  const cardItems: AccordionItem[] = [
    {
      title: formatMessage({
        id: "GUIDE_FOR_EXPERT_MEETING_FORMAT_CONTENT_1",
      }),
      content: formatMessage({
        id: "GUIDE_FOR_EXPERT_MEETING_FORMAT_CONTENT_2",
      }),
    },
    {
      title: formatMessage({
        id: "GUIDE_FOR_EXPERT_MEETING_FORMAT_CONTENT_3",
      }),
      content: formatMessage({
        id: "GUIDE_FOR_EXPERT_MEETING_FORMAT_CONTENT_4",
      }),
    },
  ];

  return (
    <section className="pt-16">
      <div className="container mx-auto">
        <div className="flex justify-center">
          <div className="w-full">
            <Markdown
              components={{
                p: ({ children, ...rest }) => (
                  <p
                    className="w-fit mx-auto mb-8 md:px-12 pt-6 text-2xl text-center border-t-1 border-t-black"
                    {...rest}
                  >
                    {children}
                  </p>
                ),
              }}
            >
              {formatMessage({
                id: "GUIDE_FOR_EXPERT_MEETING_FORMAT_TITLE",
              })}
            </Markdown>
            <div id="cards" className="flex gap-6 flex-col md:flex-row">
              {cardItems.map((item, i) => (
                <div key={i}>
                  <div className="h-full bg-white border-primary-light border-1 rounded-[58px] mb-5 md:mb-0">
                    <div className="mx-auto w-[115px] bg-primary-light text-white text-center py-1 -mt-4 z-10 relative">
                      <Markdown
                        components={{
                          p: ({ children, ...rest }) => (
                            <p className="text-lg text-center" {...rest}>
                              {children}
                            </p>
                          ),
                        }}
                      >
                        {item.title}
                      </Markdown>
                    </div>
                    <div className="pt-12 p-8">
                      <Markdown
                        components={{
                          li: ({ children, ...rest }) => (
                            <li
                              className="flex items-center gap-3 mb-1"
                              {...rest}
                            >
                              <span className="w-1 h-1 rounded-full bg-white" />
                              <span className="flex-1">{children}</span>
                            </li>
                          ),
                          ul: ({ children, ...rest }) => (
                            <ul className="list-none" {...rest}>
                              {children}
                            </ul>
                          ),
                        }}
                      >
                        {item.content}
                      </Markdown>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
